module.exports = __webpack_public_path__ + "static/media/Welpen01.90abbf07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Welpen01.jpg
// module id = 331
// module chunks = 0